<div class="info-popover flex flex-col items-center justify-center gap-2.5">
  <div class="section flex flex-row gap-2.5">
    <div class="flex flex-col">
      <span class="section_title" style="margin-bottom: 10px">Folios en blanco</span>
      <span class="section_info"
        >En esta sección puedes añadir folios en blanco tanto por delante como por detrás de tu documento.</span
      >
      <span class="section_info"
        >¡Ojo! no son copias impresas de tu documento, son folios en blanco (del mismo gramaje que el resto de tu
        documento).</span
      >
    </div>
  </div>
</div>
